module.exports = __webpack_public_path__ + "static/img/Mid-Autumnmenu10-12.c0819d1.jpg";